import { DashboardCard } from "./DashboardCard";

interface StatCardProps {
  label: string;
  value: string | number;
  helper?: string;
  children?: React.ReactNode;
  className?: string;
}

export function StatCard({
  label,
  value,
  helper,
  children,
  className,
}: StatCardProps) {
  return (
    <DashboardCard className={className || ""}>
      <div className="text-black-400 flex items-center justify-between">
        <h1 className="text-xs font-bold">{label} </h1>
        <p>{children}</p>
      </div>
      <div className="space-y-0.5">
        <div className="text-2xl leading-[36px] font-bold -tracking-wide text-white">
          {value}
        </div>
        {helper && (
          <div className="text-black-200 text-xs leading-3">{helper}</div>
        )}
      </div>
    </DashboardCard>
  );
}
